import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import {
  allowedImageFormats,
  DIALOG_DATA,
  uploadedFileCheck,
} from '../../../../global.variable';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { AppService } from '../../../app.service';

@Component({
  selector: 'gtapp-modify-letterhead-logo',
  standalone: false,
  templateUrl: './modify-letterhead-logo.component.html',
  styleUrl: './modify-letterhead-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifyLetterheadLogoComponent implements OnInit {
  logoUsed: string = '';
  siteData: any;
  clientData: any;

  selectedItem: string = '';
  constructor(
    protected dialogueRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogData: any,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private clientService: ClientsService,
    private appService: AppService,
  ) {}
  ngOnInit(): void {
    this.logoUsed = this.dialogData?.logoUsed || this.logoUsed;
    this.siteData = this.dialogData?.siteData || this.siteData;
    this.clientData = this.dialogData?.clientData || this.clientData;
  }
  onDismiss(val = false): void {
    this.dialogueRef.close(val);
  }
  removeLogo(source: string) {
    const dialogref = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete Logo`,
        message: '',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogref.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let apiFunc: any;
        switch (source) {
          case 'site':
            apiFunc = this.clientService.updateSite(this.siteData?.id, {
              remove_logo: 1,
            });
            break;
          case 'client':
            apiFunc = this.clientService.updateClient(this.clientData?.id, {
              remove_logo: 1,
            });
            break;
          case 'company':
            apiFunc = this.clientService.updateCompanyDetails(
              {},
              { remove_logo: 1 },
            );
            break;
        }

        apiFunc.then((response: any) => {
          if (response['status'] == 'success') {
            this.onDismiss(true);
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
      }
    });
  }
  openFileEditor(source: string) {
    this.selectedItem = source;
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  onFileSubmit(file: any) {
    if (!file) return;

    this.spinnerService.show('Uploading Logo');
    let fileData: FormData = new FormData();
    fileData.append('file', file);
    let apiFunc: any;
    switch (this.selectedItem) {
      case 'site':
        fileData.append('upload_logo', '1');
        apiFunc = this.appService.formDataApi(
          `site/${this.siteData?.id}/update`,
          fileData,
        );
        break;

      case 'client':
        fileData.append('upload_logo', '1');
        apiFunc = this.appService.formDataApi(
          `company/${this.clientData?.id}/update`,
          fileData,
        );
        break;

      case 'company':
        apiFunc = this.appService.formDataApi(
          'company_profile',
          fileData,
          false,
          { change_logo: 1 },
        );
        break;
    }

    apiFunc.then((response: any) => {
      if (response['status'] == 'success') {
        this.onDismiss(true);
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
      this.spinnerService.hide();
    });
  }

  async handleFileInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await uploadedFileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
}
